/**
 * 端内初始化。
 *
 * 在 main.js 里尽早调用一次。负责把原生注入的 WHParams 接到 web 既有的
 * 各套机制上（登录态、安全区、RTL），让业务代码不必知道自己跑在 App 里。
 *
 * ⚠️ 语言不在这里同步 —— 见 public/index.html 的内联脚本。原因是
 * main.js 顶部的 `import i18n from './locales'` 在模块求值期就会读
 * localStorage['language']，等 main.js 的语句执行时 i18n 早已按旧值初始化完毕。
 */
import { isEmbed, getEmbedParams } from './env'
import { setToken } from '@/utils/cache'

export { isEmbed, getEmbedParams }

let initialized = false

export function initEmbed() {
  if (initialized || !isEmbed()) return
  initialized = true

  const p = getEmbedParams()

  /**
   * 登录态：写进 localStorage，而不是改造 http.js 去读 WHParams。
   *
   * http.js:88 每个请求都现读 getToken() 再拼 Bearer，所以写进去就自然生效，
   * 既有的请求层、路由守卫、vuex 一行都不用动。
   *
   * 注意 sign_key 不写：后端已确认 timestamp/nonce/sign 不强校验（web 端同样），
   * countersign 拿不到 signKey 时会跳过加签，请求照常发出。
   */
  if (p.token) setToken(p.token)

  const root = document.documentElement

  // 端内样式开关。抵消 global.scss:45-51 的 #app{height:100vh;overflow:hidden} ——
  // embed 页不走 Layout，没有 .frameHome 的 overflow:auto，不处理会导致长页面滚不到底
  root.setAttribute('data-nr-embed', '')

  // 安全区。原生已关闭 WebView 自动内边距，避让由页面自己做（文档 §2）。
  // 单位是 pt，iOS WebView 下 1pt == 1 CSS px。
  root.style.setProperty('--nr-inset-top', `${Math.max(0, p.safeAreaTop)}px`)
  root.style.setProperty('--nr-inset-bottom', `${Math.max(0, p.safeAreaBottom)}px`)

  // RTL 不在这里设 dir —— main.js 里的 initRTLSupport() 晚于本函数执行，
  // 且会按 localStorage 的语言无条件重设，在这里设只会被覆盖。
  // 端内的方向判断已收敛进 utils/rtl.js 的 isRTLLanguage()，那里优先信 WHIsRTL。
}

export default initEmbed
